function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
import { objectToArrayOfObjects } from '@finect/front-utils/objectToArrayOfObjects';
import { getAuthRequest } from '../utils';
import { APP_SET_APP_FETCHING_STATUS, APP_SET_APP, APP_SET_APP_FIELD_VALUE, APP_SET_LAST_SESSION, APP_SET_LAST_SESSION_NOT_FOUND, APP_EDIT_LAST_SESSION_FIELD, APP_CLEAR, APP_SET_SESSION } from './constants';
export function setAppFetchingStatus(id, fetching, fetched) {
  return {
    type: APP_SET_APP_FETCHING_STATUS,
    id: id,
    fetching: fetching,
    fetched: fetched
  };
}
export function setApp(app) {
  return {
    type: APP_SET_APP,
    app: app
  };
}
export function getApp(id) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var auth = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var apps = getState().apps.apps;
    if (apps.some(function (app) {
      return app.id === id;
    }) && !force) {
      return Promise.all([]);
    }
    var authRequest = getAuthRequest(auth);
    return Promise.all([dispatch(setAppFetchingStatus(id, true, true))]).then(function () {
      return finectAPI(_objectSpread(_objectSpread({
        version: 'v4',
        path: "applications/".concat(id, "/settings?theme=default"),
        method: 'GET'
      }, authRequest), {}, {
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data;
          return dispatch(setApp(data));
        }
      }));
    });
  };
}
export function setAppField(app, field, value) {
  return {
    type: APP_SET_APP_FIELD_VALUE,
    app: app,
    field: field,
    value: value
  };
}
export function setSession(session) {
  return {
    type: APP_SET_SESSION,
    session: session
  };
}
export function fetchChangeStatus(app, session, status, auth) {
  return function (dispatch) {
    var authRequest = getAuthRequest(auth);
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "applications/".concat(app, "/sessions/").concat(session),
      method: 'PUT'
    }, authRequest), {}, {
      body: {
        items: [],
        status: status
      },
      onSuccess: function onSuccess(_ref2) {
        var data = _ref2.data;
        return dispatch(setSession(data));
      }
    }));
  };
}
export function fetchSetAppField(app, field, value, status, auth) {
  return function (dispatch, getState) {
    var promises = [dispatch(setAppField(app, field, value))];
    var authRequest = getAuthRequest(auth);
    var currentSession = getState().apps.sessions.find(function (item) {
      return item.application.id === app;
    });
    return Promise.all(promises).then(function () {
      return finectAPI(_objectSpread(_objectSpread({
        version: 'v4',
        path: currentSession ? "applications/".concat(app, "/sessions/").concat(currentSession.id) : "applications/".concat(app, "/sessions"),
        method: currentSession ? 'PUT' : 'POST'
      }, authRequest), {}, {
        body: {
          items: [{
            field: field,
            value: value
          }],
          status: status
        },
        onSuccess: function onSuccess(_ref3) {
          var data = _ref3.data;
          return dispatch(setSession(data));
        }
      }));
    });
  };
}
export function fetchSetAppFields(app, fields, status, auth) {
  var items = objectToArrayOfObjects(fields, 'field', 'value');
  return function (dispatch, getState) {
    var promises = items.map(function (field) {
      return dispatch(setAppField(app, field.field, field.value));
    });
    var authRequest = getAuthRequest(auth);
    var currentSession = getState().apps.sessions.find(function (item) {
      return item.application.id === app;
    });
    return Promise.all(promises).then(function () {
      return finectAPI(_objectSpread(_objectSpread({
        version: 'v4',
        path: currentSession ? "applications/".concat(app, "/sessions/").concat(currentSession.id) : "applications/".concat(app, "/sessions"),
        method: currentSession ? 'PUT' : 'POST'
      }, authRequest), {}, {
        body: {
          items: items,
          status: status
        },
        onSuccess: function onSuccess(_ref4) {
          var data = _ref4.data;
          return dispatch(setSession(data));
        }
      }));
    });
  };
}
export function setAppLastSession(app, lastSession) {
  return {
    type: APP_SET_LAST_SESSION,
    app: app,
    lastSession: lastSession
  };
}
export function editAppLastSessionField(app, status, fields, id) {
  return {
    type: APP_EDIT_LAST_SESSION_FIELD,
    app: app,
    status: status,
    fields: fields,
    id: id
  };
}
export function setAppLastSessionNotFound(app) {
  return {
    type: APP_SET_LAST_SESSION_NOT_FOUND,
    app: app,
    lastSession: null
  };
}
export function getAppLastSession(app, auth) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "applications/".concat(app, "/sessions/last"),
      method: 'GET',
      credentials: auth,
      onSuccess: function onSuccess(_ref5) {
        var data = _ref5.data;
        return dispatch(setAppLastSession(app, data));
      },
      onError: function onError() {
        return dispatch(setAppLastSessionNotFound(app));
      }
    });
  };
}
export function fetchAppUpdateLastSession(app, auth) {
  var authRequest = getAuthRequest(auth);
  return function (dispatch, getState) {
    var object = getState().apps.lastSessions.find(function (_ref6) {
      var id = _ref6.id;
      return id === app;
    });
    var exists = Boolean(object.model.id);
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "applications/".concat(object.id, "/sessions").concat(exists ? "/".concat(object.model.id) : ''),
      method: exists ? 'PUT' : 'POST',
      referrerPolicy: 'no-referrer-when-downgrade',
      body: {
        items: object.model.items,
        status: object.model.status
      }
    }, authRequest), {}, {
      onSuccess: function onSuccess(_ref7) {
        var data = _ref7.data;
        return dispatch(editAppLastSessionField(app, data.status, arrayOfObjectsToObject(data.items, 'field', 'value'), data.id));
      }
    }));
  };
}
export function editAndUpdateAppLastSession(app, status, fields, auth) {
  return function (dispatch, getState) {
    var _getState$user$user$i = getState().user.user.isLoggedIn,
      isLoggedIn = _getState$user$user$i === void 0 ? false : _getState$user$user$i;
    Promise.all([dispatch(editAppLastSessionField(app, status, fields))]).then(function () {
      return isLoggedIn ? Promise.all([dispatch(fetchAppUpdateLastSession(app, auth))]) : Promise.all([]);
    });
  };
}
export function clearApps() {
  return {
    type: APP_CLEAR
  };
}